import { Injectable, signal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { noMatch } from '@core/misc/validators.utils';
import { authChangePassword, authResetLoadState } from '@core/modules/auth/state/auth.actions';
import { NGXS_CHANGE_PSWD_FORM } from '@core/modules/auth/state/auth.const';
import { AuthState } from '@core/modules/auth/state/auth.state';
import { dispatch, select } from '@ngxs/store';

@Injectable()
export class ChangePasswordPageService {
  readonly #resetLoadState = dispatch(authResetLoadState);
  readonly #changePassword = dispatch(authChangePassword);

  public readonly formLoadState = select(AuthState.changePasswordFormStates);
  public readonly isSubmited = signal<boolean>(false);
  readonly ngxsForm = NGXS_CHANGE_PSWD_FORM;
  readonly formGroup = new FormGroup({
    oldPassword: new FormControl('', [Validators.required]),
    newPassword: new FormControl('', [Validators.required, Validators.minLength(4)]),
    confirmPassword: new FormControl('', [Validators.required, Validators.minLength(4), noMatch('newPassword')])
  });

  init(): void {
    this.#resetLoadState();
  }

  onTogglePasswordVisibility(element: HTMLInputElement): void {
    element.type = element.type === 'text' ? 'password' : 'text';
  }
  onSubmit() {
    if (!this.isSubmited()) this.isSubmited.update(() => true);
    if (this.formGroup.valid) {
      this.#changePassword();
    }
  }
}
